import { render, staticRenderFns } from "./DeleteCreative.vue?vue&type=template&id=e8b8e380"
import script from "./DeleteCreative.vue?vue&type=script&lang=js"
export * from "./DeleteCreative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports